import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contract_accessorial_charges_template_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.id)) {
      missingRequiredInParams.push('\'id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_accessorial_charges_template_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id: number    }) {
        if(isNil(inParams.id)) {
          return true; 
        }
      return false;
    }
}
